import React from 'react';
import { motion } from 'framer-motion';
import { SearchCheckIcon, GavelIcon, TrendingUpIcon } from 'lucide-react';
const CTA_URL = 'https://wa.me/17863763985';
const STEPS = [{
  number: '1',
  icon: SearchCheckIcon,
  iconBg: 'bg-[#7B2FE0]',
  badgeBg: 'bg-[#7B2FE0]',
  title: 'Consulta Gratis',
  description: 'Comenzamos con un análisis gratuito de tu reporte de crédito para identificar qué está afectando tu perfil y estructurar un plan de acción personalizado basado en tus objetivos financieros.'
}, {
  number: '2',
  icon: GavelIcon,
  iconBg: 'bg-[#F59E0B]',
  badgeBg: 'bg-[#F59E0B]',
  title: 'Proceso de Disputa',
  description: 'Iniciamos la fase de restauración disputando estratégicamente las cuentas negativas, errores o información inexacta que pueda estar afectando tu reporte de crédito.'
}, {
  number: '3',
  icon: TrendingUpIcon,
  iconBg: 'bg-[#00B67A]',
  badgeBg: 'bg-[#00B67A]',
  title: 'Acompañamiento y Avances',
  description: 'Te acompañamos durante cada etapa del proceso, damos seguimiento a tus resultados y te guiamos con recomendaciones para optimizar tu perfil crediticio.'
}];
export function ComoFunciona() {
  return <section className="w-full bg-[#F5F5F5] py-14 md:py-20 px-5" data-id="element-271">
      <div className="max-w-5xl mx-auto" data-id="element-272">
        <div className="text-center mb-12" data-id="element-273">
          <span className="inline-block bg-[#7B2FE0] text-white text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-5" data-id="element-274">
            ¿Cómo Funciona?
          </span>
          <h2 className="text-2xl md:text-4xl font-extrabold text-[#0A0A0A]" style={{
          fontFamily: 'Manrope, Inter, sans-serif'
        }} data-id="element-275">
            Un proceso claro en 3 pasos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-276">
          {STEPS.map((step, i) => {
          const Icon = step.icon;
          return <motion.div key={step.number} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="bg-white rounded-2xl p-7 text-center shadow-sm border border-gray-100" data-id="element-277">
                <div className={`relative inline-flex items-center justify-center w-16 h-16 rounded-2xl ${step.iconBg} mb-5 shadow-lg`} data-id="element-278">
                  <Icon className="w-8 h-8 text-white" data-id="element-279" />
                  <span className={`absolute -top-2 -right-2 w-7 h-7 rounded-full ${step.badgeBg} text-white text-sm font-bold flex items-center justify-center ring-4 ring-white`} data-id="element-280">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-lg font-bold text-[#0A0A0A] mb-2 uppercase tracking-wide" style={{
              fontFamily: 'Manrope, Inter, sans-serif'
            }} data-id="element-281">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-282">
                  {step.description}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="text-center mt-12" data-id="element-283">
          <a href={CTA_URL} className="inline-block w-full sm:w-auto" data-id="element-284">
            <motion.button type="button" whileHover={{
            scale: 1.04
          }} whileTap={{
            scale: 0.97
          }} className="w-full sm:w-auto px-12 py-4 bg-[#7B2FE0] text-white font-bold text-base uppercase tracking-wide rounded-full shadow-lg shadow-[#7B2FE0]/30 hover:bg-[#6a23c7] transition-colors" data-id="element-285">
              Consulta Gratis
            </motion.button>
          </a>
        </div>
      </div>
    </section>;
}